<template>
  <div>
    <v-card class="mt-4">
      <v-card-title>
        <ProgresoParte 
          v-if="parte.horasEstimadas !== null && parte.horasEstimadas > 0 "
          :horasPonderadas="horasPonderadas"
          :horasEstimadas="parseInt(parte.horasEstimadas)"
        />
        <v-text-field
          v-model="buscarAcciones"
          append-icon="mdi-file-search-outline"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headersAcciones"
        :items="parte.acciones"
        :search="buscarAcciones"
        multi-sort
        :item-class="getClass"
        :sort-by="['fecha', 'entrada']"
        :sort-desc="[true, true]"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>Acciones</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              v-if="parte.acciones.length > 0"
              class="mr-4"
              color="primary"
              outlined
              @click="moverAcciones()"
              :disabled="guardadoDeshabilitado || soloLectura || !parte.id"
            >
              Mover acciones
            </v-btn>

            <MoverAcciones
              v-model="dialogMoverAccion"
              :usuarios="usuarios"
              :clientes="clientes"
              :acciones="parte.acciones"
              :headersPartes="
                headersPartes.filter((header) => header.value != 'acciones')
              "
              v-if="parte.id"
              :parteId="parte.id"
              @actualizarAcciones="quitarAcciones($event)"
            />
            <v-btn
              color="primary"
              outlined
              @click="insertarAccion()"
              :disabled="soloLectura || !tienePermisosEnComponenteId(11)"
            >
              Insertar acción
            </v-btn>
          </v-toolbar>
        </template>

        <template v-slot:item.user.name="{ item }">
          <v-chip outlined>
            <v-avatar left :color="item.user.color">
              <span class="white--text">
                {{ item.user.avatar }}
              </span>
            </v-avatar>
            {{ item.user.name }}
          </v-chip>
        </template>

        <template v-slot:item.fecha="{ item }">
          {{ formatDate(item.fecha) }}
        </template>
        <template v-slot:item.comentarios="{ item }">
          <v-textarea
            v-model="item.comentarios"
            readonly
            hide-details
            :rows="
              item.comentarios.length / 50 > 3
                ? 3
                : Math.ceil(item.comentarios.length / 50)
            "
            class="comentario"
          ></v-textarea>
        </template>
        <template v-slot:item.acciones="{ item }">
          <v-icon class="mr-2" @click="editarAccion(item)">
            mdi-file-document-edit-outline
          </v-icon>

          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon> mdi-information-outline </v-icon>
              </v-btn>
            </template>
            <span> {{ obtenerHorasRealesFormateadas(item.horasReales) }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.desplazamiento="{ item }">
          <v-checkbox v-model="item.desplazamiento" disabled></v-checkbox>
        </template>
        <template v-slot:item.fuera_horas="{ item }">
          <v-checkbox v-model="item.fuera_horas" disabled></v-checkbox>
        </template>
        <template v-slot:item.asistencia_minima="{ item }">
          <v-checkbox v-model="item.asistencia_minima" disabled></v-checkbox>
        </template>
      </v-data-table>
    </v-card>
    <v-row justify="center">
      <v-dialog v-model="dialogAccion" persistent max-width="800px">
        <v-card>
          <v-card-title class="headline">
            {{ tituloDialogAccion }}
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-alert
                  dense
                  outlined
                  border="left"
                  type="warning"
                  icon="mdi-alert-outline"
                  v-if="accion.bloqueada != null"
                >
                  Esta acción está bloqueada por un asiento de cierre y no puede
                  ser modificada
                </v-alert>
                <v-alert
                  dense
                  outlined
                  border="left"
                  type="warning"
                  icon="mdi-alert-outline"
                  v-else-if="soloLectura"
                >
                  Esta acción está bloqueada porque el parte se abrió como solo lectura o ya está facturado.
                </v-alert>
                <v-alert
                  dense
                  outlined
                  border="left"
                  type="warning"
                  icon="mdi-alert-outline"
                  v-else-if="!accion.esEditable"
                >
                  No tienes permisos para editar esta acción.
                </v-alert>
                <v-alert
                  dense
                  outlined
                  border="left"
                  type="info"
                  icon="mdi-alert-outline"
                  v-else-if="parte.tipo_parte"
                >
                  Este parte está asociado al contrato "{{
                    parte.tipo_parte.contrato
                  }}".
                </v-alert>
                <v-autocomplete
                  v-model="accion.user"
                  :items="tecnicos"
                  chips
                  color="blue-grey lighten-2"
                  label="Técnico asignado"
                  item-text="name"
                  item-value="id"
                  @input="$v.accion.user.id.$touch()"
                  @blur="$v.accion.user.id.$touch()"
                  :error-messages="errorUsuario"
                  return-object
                  :disabled="soloLectura || !accion.esEditable"
                  class="anadirAsterisco"
                >
                  <template v-slot:selection="data">
                    <v-chip v-bind="data.attrs" :input-value="data.selected">
                      <v-avatar left :color="data.item.color">
                        <span class="white--text">{{ data.item.avatar }}</span>
                      </v-avatar>
                      {{ data.item.name + " " + data.item.apellidos }}
                    </v-chip>
                  </template>
                  <template v-slot:item="data">
                    <template>
                      <v-list-item-avatar :color="data.item.color">
                        <span class="white--text">{{ data.item.avatar }}</span>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title>{{
                          data.item.name
                        }}</v-list-item-title>
                        <v-list-item-subtitle>{{
                          data.item.apellidos
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" md="4">
                <v-select
                  v-model="accion.contrato"
                  label="Contrato"
                  @input="$v.accion.contrato.$touch()"
                  @blur="$v.accion.contrato.$touch()"
                  @change="() => {
                    if(!accion.contrato.ambitos.map(ambito => ambito.id).includes(accion.ambito.id))
                      accion.ambito = ''
                  }"
                  :error-messages="errorContrato"
                  :items="contratosActivos"
                  item-text="contrato"
                  item-value="id"
                  return-object
                  :disabled="soloLectura || !accion.esEditable"
                  class="anadirAsterisco"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <v-select
                  v-model="accion.ambito"
                  label="Ámbito"
                  @input="$v.accion.ambito.id.$touch()"
                  @blur="$v.accion.ambito.id.$touch()"
                  :error-messages="errorAmbito"
                  :items="accion.contrato.ambitos"
                  item-text="ambito"
                  item-value="id"
                  return-object
                  :disabled="soloLectura || !accion.esEditable"
                  class="anadirAsterisco"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <v-select
                  v-model="accion.urgencia"
                  label="Urgencia"
                  @input="$v.accion.urgencia.id.$touch()"
                  @blur="$v.accion.urgencia.id.$touch()"
                  :error-messages="errorUrgencia"
                  :items="gradosUrgencia"
                  item-text="urgencia"
                  item-value="id"
                  return-object
                  :hint="accion.urgencia.comentarios"
                  persistent-hint
                  :disabled="soloLectura || !accion.esEditable"
                  class="anadirAsterisco"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" md="4">
                <v-dialog
                  ref="dialogFecha"
                  v-model="modalFecha"
                  :return-value.sync="accion.fecha"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="accion.fechaFormateada"
                      label="Fecha"
                      v-bind="attrs"
                      v-on="on"
                      @blur="accion.fecha = parseDate(accion.fechaFormateada)"
                      readonly
                      :disabled="soloLectura || !accion.esEditable"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="accion.fecha"
                    scrollable
                    :first-day-of-week="1"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="modalFecha = false"
                      >Cancelar</v-btn
                    >
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.dialogFecha.save(accion.fecha)"
                      >Aceptar</v-btn
                    >
                  </v-date-picker>
                </v-dialog>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <v-dialog
                  ref="dialogHoraInicio"
                  v-model="modalHoraInicio"
                  :return-value.sync="accion.entrada"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="accion.entrada"
                      label="Inicio"
                      @input="$v.accion.entrada.$touch()"
                      @blur="$v.accion.entrada.$touch()"
                      :error-messages="errorEntrada"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :disabled="soloLectura || !accion.esEditable"
                      class="anadirAsterisco" 
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    v-if="modalHoraInicio"
                    v-model="accion.entrada"
                    format="24hr"
                    full-width
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="modalHoraInicio = false"
                      >Cancelar</v-btn
                    >
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.dialogHoraInicio.save(accion.entrada)"
                      >Aceptar</v-btn
                    >
                  </v-time-picker>
                </v-dialog>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <v-dialog
                  ref="dialogHoraFin"
                  v-model="modalHoraFin"
                  :return-value.sync="accion.salida"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="accion.salida"
                      label="Fin"
                      @input="$v.accion.salida.$touch()"
                      @blur="$v.accion.salida.$touch()"
                      :error-messages="errorSalida"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :disabled="soloLectura || !accion.esEditable"
                      class="anadirAsterisco"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    v-if="modalHoraFin"
                    v-model="accion.salida"
                    format="24hr"
                    full-width
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="modalHoraFin = false"
                      >Cancelar</v-btn
                    >
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.dialogHoraFin.save(accion.salida)"
                      >Aceptar</v-btn
                    >
                  </v-time-picker>
                </v-dialog>
              </v-col>
            </v-row>
            <v-row v-if="activarTarde">
              <v-col cols="12">
                <v-alert
                  v-if="accion.desplazamiento"
                  dense
                  outlined
                  border="left"
                  type="info"
                  icon="mdi-information-outline"
                >
                  La acción tiene un desplazamiento marcado. Ten en cuenta que la acción de la tarde se generará sin desplazamiento.
                </v-alert>
                <v-card outlined>
                  <v-card-subtitle class="pb-1">Tarde</v-card-subtitle>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" sm="6" md="6">
                        <v-dialog
                          ref="dialogHoraInicioTarde"
                          v-model="modalHoraInicioTarde"
                          :return-value.sync="horaInicioTarde"
                          persistent
                          width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="horaInicioTarde"
                              label="Inicio"
                              @input="$v.horaInicioTarde.$touch()"
                              @blur="$v.horaInicioTarde.$touch()"
                              :error-messages="errorEntradaTarde"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              :disabled="soloLectura || !accion.esEditable"
                              class="anadirAsterisco" 
                            ></v-text-field>
                          </template>
                          <v-time-picker
                            v-if="modalHoraInicioTarde"
                            v-model="horaInicioTarde"
                            format="24hr"
                            full-width
                          >
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="modalHoraInicioTarde = false"
                              >Cancelar</v-btn
                            >
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.dialogHoraInicioTarde.save(horaInicioTarde)"
                              >Aceptar</v-btn
                            >
                          </v-time-picker>
                        </v-dialog>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-dialog
                          ref="dialogHoraFinTarde"
                          v-model="modalHoraFinTarde"
                          :return-value.sync="horaFinTarde"
                          persistent
                          width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="horaFinTarde"
                              label="Fin"
                              @input="$v.horaFinTarde.$touch()"
                              @blur="$v.horaFinTarde.$touch()"
                              :error-messages="errorSalidaTarde"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              :disabled="soloLectura || !accion.esEditable"
                              class="anadirAsterisco"
                            ></v-text-field>
                          </template>
                          <v-time-picker
                            v-if="modalHoraFinTarde"
                            v-model="horaFinTarde"
                            format="24hr"
                            full-width
                          >
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="modalHoraFinTarde = false"
                              >Cancelar</v-btn
                            >
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.dialogHoraFinTarde.save(horaFinTarde)"
                              >Aceptar</v-btn
                            >
                          </v-time-picker>
                        </v-dialog>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-textarea
                  class="mx-2 anadirAsterisco"
                  label="Comentarios"
                  v-model="accion.comentarios"
                  @input="$v.accion.comentarios.$touch()"
                  @blur="$v.accion.comentarios.$touch()"
                  :error-messages="errorComentarios"
                  no-resize
                  :disabled="soloLectura || !accion.esEditable"
                  prepend-icon="mdi-playlist-star"
                  @click:prepend="dialogComentariosGuardados = true"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-menu offset-y :close-on-content-click="false">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" block outlined>
                      Más opciones
                    </v-btn>
                  </template>
                  <v-list dense>
                    <v-list-item>
                      <v-list-item-title class="px-2">
                        <v-checkbox
                          class="mb-2"
                          hide-details
                          label="Desplazamiento"
                          v-model="accion.desplazamiento"
                          @change="comprobarTiempo($event)"
                          :disabled="soloLectura || !accion.esEditable"
                        ></v-checkbox>
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-title class="px-2">
                        <v-checkbox
                          class="mb-2"
                          hide-details
                          label="Asistencia mínima"
                          v-model="accion.asistencia_minima"
                          :disabled="soloLectura || !accion.esEditable"
                        ></v-checkbox>
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="authUser.isAdmin || authUser.isAdmon">
                      <v-list-item-title class="px-2">
                        <v-checkbox
                          class="mb-2"
                          hide-details
                          label="Abono"
                          v-model="accion.abono"
                          :disabled="soloLectura || !accion.esEditable"
                        ></v-checkbox>
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-title class="px-2">
                        <v-checkbox
                          class="mb-2"
                          hide-details
                          label="APV"
                          v-model="accion.apv"
                          :disabled="soloLectura || !accion.esEditable"
                        ></v-checkbox>
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-title class="px-2">
                        <v-checkbox
                          class="mb-2"
                          hide-details
                          label="Añadir tarde"
                          v-model="activarTarde"
                          :disabled="soloLectura || !accion.esEditable"
                        ></v-checkbox>
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-btn
              v-if="editando"
              color="error"
              text
              @click="dialogEliminar = true"
              :disabled="accion.bloqueada != null || soloLectura || !accion.esEditable"
              >Eliminar</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn
              color="error"
              text
              @click="cerrarDialogAccion()"
              >Cancelar</v-btn
            >
            <v-btn
              text
              @click="accionAlImputar()"
              :disabled="
                $v.$invalid ||
                accion.bloqueada != null ||
                soloLectura ||
                !accion.esEditable
              "
            >
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogEliminar" persistent max-width="380">
        <v-card>
          <v-card-title class="headline">¡Atención!</v-card-title>
          <v-card-text>Vas a eliminar esta acción. ¿Estás seguro?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialogEliminar = false">Cancelar</v-btn>
            <v-btn color="error" text @click="eliminarAccion(accion)"
              >Eliminar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      
      <v-dialog v-model="dialogAvisoMateriales" persistent max-width="500">
        <v-card>
          <v-card-title class="headline">Recordatorio</v-card-title>
          <v-card-text>
            <ul>
              <li>
                Estás imputando una acción con desplazamiento, de haber utilizado materiales, recuerda ir al apartado de materiales para añadirlos.
              </li>
              <li>
                El desplazamiento que has marcado se ha asociado a la delegación indicada en el parte:
                <center>
                  <h3>{{ delegacionParte }}</h3>
                </center>
              </li>
            </ul>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialogAvisoMateriales = false; aceptarAccion()">Aceptar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <ComentariosGuardados 
        :dialogComentariosGuardados="dialogComentariosGuardados" 
        @close="dialogComentariosGuardados = false"
        @aceptar="insertarComentario"
      />
    </v-row>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import ProgresoParte from "./ProgresoParte";
import formatearFecha from "../../mixins/formatearFecha";
import getArrayPositionByItemId from "../../mixins/getArrayPositionByItemId";
import uuidv4 from "../../mixins/uuidv4";
import { required, requiredIf, helpers } from "vuelidate/lib/validators";
import MoverAcciones from "../partes/MoverAcciones.vue";
import ComentariosGuardados from '../comentariosGuardados/ComentariosGuardados.vue'
const greaterOrEqualThan = (param) => helpers.withParams(
    { value: param },
    (value) => !helpers.req(value) || value >= param)
export default {
  name: "Acciones",
  mixins: [formatearFecha, getArrayPositionByItemId, uuidv4],
  props: [
    "parte",
    "contratos",
    "ambitos",
    "gradosUrgencia",
    "usuarios",
    "tecnicos",
    "clientes",
    "headersPartes",
    "guardadoDeshabilitado",
    "delegaciones"
  ],
  components: {
    MoverAcciones, ProgresoParte, ComentariosGuardados
  },
  data() {
    return {
      dialogMoverAccion: false,
      dialogAccion: false,
      dialogEliminar: false,
      tituloDialogAccion: "",
      editando: false,
      modalFecha: false,
      modalHoraInicio: false,
      modalHoraFin: false,
      modalHoraFinTarde: false,
      modalHoraInicioTarde: false,
      horaInicio: "",
      horaFin: "",
      horaInicioTarde: "",
      horaFinTarde: "",
      headersAcciones: [
        {
          text: "Técnico",
          align: "start",
          filterable: true,
          sortable: true,
          value: "user.name",
          width: "5%",
        },
        {
          text: "Tipo acción",
          filterable: true,
          sortable: true,
          value: "contrato.contrato",
          width: "7%",
        },
        {
          text: "Ámbito",
          filterable: true,
          sortable: true,
          value: "ambito.ambito",
          width: "6%",
        },
        {
          text: "Urgencia",
          filterable: true,
          sortable: true,
          value: "urgencia.urgencia",
          width: "6%",
        },
        {
          text: "Fecha",
          filterable: true,
          sortable: true,
          value: "fecha",
          width: "5%",
        },
        {
          text: "Entrada",
          filterable: false,
          sortable: true,
          value: "entrada",
          width: "5%",
        },
        {
          text: "Salida",
          filterable: false,
          sortable: false,
          value: "salida",
          width: "5%",
        },
        {
          text: "Comentarios",
          filterable: true,
          sortable: false,
          value: "comentarios",
          width: "40%",
        },
        {
          text: "Desp",
          filterable: false,
          sortable: false,
          value: "desplazamiento",
          width: "2%",
        },
        {
          text: "Asis min",
          filterable: false,
          sortable: false,
          value: "asistencia_minima",
          width: "2%",
        },
        {
          text: "",
          filterable: false,
          sortable: false,
          value: "acciones",
          width: "8%",
        },
      ],
      buscarAcciones: "",
      accion: {
        urgencia: {
          comentarios: "",
        },
        contrato: {
          id: '',
          contrato: '',
          ambitos: []
        }
      },
      dialogAvisoMateriales: false,
      activarTarde: false,
      dialogComentariosGuardados: false
    };
  },
  validations() {
    return {
      accion: {
        user: {
          id: { required },
        },
        contrato: {
          id: { required },
        },
        ambito: {
          id: { required },
        },
        urgencia: {
          id: { required },
        },
        fecha: { required },
        entrada: { required },
        salida: { 
          required,
          greaterOrEqualThan: greaterOrEqualThan(this.accion.entrada)
        },
        comentarios: { required },
      },
      horaInicioTarde: { 
        required: requiredIf(function() {
          return this.activarTarde;
        }),
        greaterOrEqualThan: greaterOrEqualThan(this.accion.salida)

      },
      horaFinTarde: { 
        required: requiredIf(function() {
          return this.activarTarde;
        }),
        greaterOrEqualThan: greaterOrEqualThan(this.horaInicioTarde)
      }
    }
  },
  methods: {
    ...mapActions("partes", ["setDialog"]),
    ...mapActions("calculoHoras", ["setHorasPonderadas"]),
    ...mapActions(["setLoading", "setSnackbar"]),
    ...mapActions({
      guardarParte: 'acciones/guardarParte'
    }),
    avisoCerrar() {
      this.dialogCerrar = true;
    },
    cerrar() {
      this.dialogCerrar = false;
      this.setDialog(false);
    },
    aceptarAccion() {
      this.accion.horasReales = this.calcularHorasReales(
        this.accion.entrada,
        this.accion.salida
      );
      this.accion.horasPonderadas = this.calcularHorasPonderadas(this.accion);
      if (this.editando) {
        let posicionArray = this.getArrayPositionByItemId(
          this.parte.acciones,
          this.accion.id
        );

        this.parte.acciones[posicionArray] = Object.assign({}, this.accion);

        let shift = this.parte.acciones.shift();
        this.parte.acciones.unshift(shift);

        // Insertamos la acción modificada en el array de acciones modificadas si no es una acción nueva creada ahora
        // Para evitar que al modificar varias veces la misma acción se cree más de una vez la acción en el array,
        if (typeof this.accion.id === "number") {
          // buscamos primero si la acción está en el array, si está la sobreescribimos con la nueva, si no, la insertamos en el array
          let indiceAccionModificada = this.parte.accionesModificadas.findIndex(
            (x) => x.id === this.accion.id
          );
          if (indiceAccionModificada === -1) {
            this.parte.accionesModificadas.push(this.accion);
          } else {
            this.parte.accionesModificadas[indiceAccionModificada] =
              this.accion;
          }
        }
      } else {
        this.parte.acciones.push(this.accion);
      }

      if(this.activarTarde){
        let accionTarde = Object.assign({}, this.accion);
        accionTarde.id = this.uuidv4();
        accionTarde.entrada = this.horaInicioTarde;
        accionTarde.salida = this.horaFinTarde;
        accionTarde.horasReales = this.calcularHorasReales(
          accionTarde.entrada,
          accionTarde.salida
        );
        accionTarde.desplazamiento = false;
        this.parte.acciones.push(accionTarde);
      }
      this.setHorasPonderadas(this.parte.acciones);
      this.cerrarDialogAccion();
    },
    editarAccion(accion) {
      this.accion = JSON.parse(JSON.stringify(accion));
      // this.accion = {
      //   id: accion.id,
      //   user: {
      //     id: accion.user.id,
      //     name: accion.user.name,
      //     apellidos: accion.user.apellidos,
      //     avatar: accion.user.avatar,
      //     color: accion.user.color,
      //   },
      //   contrato: {
      //     id: accion.contrato.id,
      //     contrato: accion.contrato.contrato,
      //     ambitos: accion.contrato.ambitos
      //   },
      //   ambito: {
      //     id: accion.ambito.id,
      //     ambito: accion.ambito.ambito,
      //   },
      //   urgencia: {
      //     id: accion.urgencia.id,
      //     urgencia: accion.urgencia.urgencia,
      //     comentarios: accion.urgencia.comentarios,
      //   },
      //   fecha: accion.fecha,
      //   horasReales: accion.horasReales,
      //   fechaFormateada: this.formatDate(
      //     new Date(accion.fecha).toISOString().substr(0, 10)
      //   ),
      //   entrada: accion.entrada,
      //   salida: accion.salida,
      //   comentarios: accion.comentarios,
      //   desplazamiento: accion.desplazamiento,
      //   asistencia_minima: accion.asistencia_minima,
      //   abono: accion.abono,
      //   apv: accion.apv,
      //   bloqueada: accion.bloqueada,
      // };
      // console.log(this.accion);
      this.accion.fechaFormateada = this.formatDate(
        new Date(accion.fecha).toISOString().substr(0, 10)
      );

      this.tituloDialogAccion = "Editar acción";
      this.editando = true;
      this.dialogAccion = true;
    },
    insertarAccion() {

      this.accion = {
        id: this.uuidv4(),
        user: {
          id: this.authUser.id,
          name: this.authUser.name,
          apellidos: this.authUser.apellidos,
          avatar: this.authUser.avatar,
          color: this.authUser.color,
        },
        contrato: {
          id: '',
          contrato: '',
          ambitos: []
        },
        ambito: {
          id: "",
          ambito: "",
        },
        urgencia: {
          id: 4,
          urgencia: "Normal",
          comentarios: "",
        },
        fecha: new Date().toISOString().substr(0, 10),
        fechaFormateada: this.formatDate(
          new Date().toISOString().substr(0, 10)
        ),
        esEditable: true,
        entrada: "",
        salida: "",
        comentarios: "",
        desplazamiento: false,
        asistencia_minima: false,
        abono: false,
        apv: false,
        bloqueada: null,
      };
      // if(this.tecnicos.map(tecnico => tecnico.id).includes(this.authUser.id)){
      //   this.accion.user.id = this.authUser.id;
      //   this.accion.user.name = this.authUser.name;
      //   this.accion.user.apellidos = this.authUser.apellidos;
      //   this.accion.user.avatar = this.authUser.avatar;
      //   this.accion.user.color = this.authUser.color;
      // }
      this.editando = false;
      this.tituloDialogAccion = "Nueva acción";
      this.dialogAccion = true;
    },
    eliminarAccion(accion, borrar = true) {
      let posicionArray = this.getArrayPositionByItemId(
        this.parte.acciones,
        accion.id
      );
      if (borrar) {
        this.parte.accionesEliminadas.push(accion);
      }
      this.parte.acciones.splice(posicionArray, 1);
      this.setHorasPonderadas(this.parte.acciones);
      this.dialogEliminar = false;
      this.dialogAccion = false;
    },
    cerrarDialogAccion(){
      this.dialogAccion = false;
      this.activarTarde = false;
      this.horaInicioTarde = "";
      this.horaFinTarde = "";
      this.$v.$reset();
    },
    async moverAcciones(){
      const materialesRequest = await this.$store.dispatch('materiales/getMaterialesRequest');
      this.parte.materiales = materialesRequest;
      this.dialogMoverAccion = true;
      this.guardarParte();
    },
    getClass(accion) {
      if (accion.abono) {
        return "error";
      }
      if (accion.apv) {
        return "warning";
      }
      return "";
    },
    comprobarTiempo(valor) {
      // Al marcar el check de desplazamiento se verifica el tiempo de la acción. Si la acción es inferior a 1 hora, se marca automáticamente el check de asistencia mínima.
      if (valor) {
        if (this.accion.entrada !== "" && this.accion.salida !== "") {
          let entrada = Date.parse("01/01/2021 " + this.accion.entrada);
          let salida = Date.parse("01/01/2021 " + this.accion.salida);
          let tiempoAccion = (salida - entrada) / 1000 / 3600;
          if (tiempoAccion < 1 && tiempoAccion >= 0) {
            this.accion.asistencia_minima = true;
          }
          // console.log(tiempoAccion);
        } else {
          this.accion.asistencia_minima = true;
        }
      }
    },
    fecha() {
      return this.accion.fecha;
    },
    obtenerHorasRealesFormateadas(n) {
      let result = "N/A";

      if (Number(n) === n && (n % 1 !== 0 || n % 1 === 0)) {
        let horas = n > 0 ? Math.floor(n) : Math.ceil(n);
        let minutos = n > 0 ? (n % 1) * 60 : -((n % 1) * 60);
        minutos = Math.round((minutos + Number.EPSILON) * 100) / 100;
        minutos = Math.round(minutos);
        result = `Horas reales: ${horas} horas`;
        result += minutos != 0 ? ` ${minutos} minutos.` : ".";
      }
      return result;
    },
    calcularHorasReales(entrada, salida) {
      let entradaHoras = entrada.split(":")[0];
      let entradaMinutos = entrada.split(":")[1];
      entrada = new Date(2021, 1, 1, entradaHoras, entradaMinutos);

      let salidaHoras = salida.split(":")[0];
      let salidaMinutos = salida.split(":")[1];
      salida = new Date(2021, 1, 1, salidaHoras, salidaMinutos);

      entrada = entrada.getTime();
      salida = salida.getTime();

      let horasReales = (salida - entrada) / (3600 * 1000);
      horasReales = this.accion.abono == 1 ? -1 * horasReales : horasReales;
      return horasReales;
    },
    quitarAcciones(acciones) {
      // console.log(acciones);
      for (const accion of acciones) {
        this.eliminarAccion(accion, false);
      }
    },
    accionAlImputar() {
      if(this.accion.desplazamiento) {
        this.dialogAvisoMateriales = true;
      }
      else {
        this.aceptarAccion();
      }
    },
    calcularHorasPonderadas(accion) {
      let tiempoAccionPonderado = 0;
      let entrada = null;
      let salida = null;
      entrada = new Date(accion.fecha + " " + accion.entrada);
      salida = new Date(accion.fecha + " " + accion.salida);
      if (entrada > salida) {
          //Si la entrada es después de la salida sumamos un dia a la salida para que calcule bien el tiempo
        salida.setDate(salida.getDate() + 1);
      }

      let tiempoAccion = (salida.getTime() - entrada.getTime()) / 3600000;
      if(accion.asistencia_minima){
        tiempoAccion = 1;
      }
      console.log(tiempoAccion);

      let factorTecnico = (this.usuarios.find(usuario => usuario.id === accion.user.id))?.tipo_usuario.valor;
      console.log(factorTecnico);

      let factorUrgencia = (this.gradosUrgencia.find(gradoUrgencia => gradoUrgencia.id === accion.urgencia.id))?.factor;
      console.log(factorUrgencia);

      let factorAmbito = (this.ambitos.find(ambito => ambito.id === accion.ambito.id))?.servicio.factor;
      console.log(factorAmbito);

      let factorDesplazamiento = 0;
      if(accion.desplazamiento){ // Se ha marcado desplazamiento para esta acción
        factorDesplazamiento = (this.delegaciones.find(delegacion => delegacion.delegacionId === this.parte.delegacion_id))?.factor;
      }
      console.log(factorDesplazamiento);
      tiempoAccionPonderado = tiempoAccion * factorTecnico * factorAmbito * factorUrgencia + factorDesplazamiento;
      if (accion.abono) {
        tiempoAccionPonderado = tiempoAccionPonderado * -1;
      }
      return tiempoAccionPonderado;
    },
    insertarComentario(comentarios){
      if(this.accion.comentarios.length > 0) this.accion.comentarios += '\n'
      comentarios.forEach((comentario, index, comentarios) => {
        this.accion.comentarios += comentario.texto
        if(index < comentarios.length-1){
          this.accion.comentarios += '\n'
        }
      });
      this.dialogComentariosGuardados = false
    }
  },
  computed: {
    ...mapState("partes", ["dialog"]),
    ...mapState("calculoHoras", ["horasPonderadas"]),
    ...mapState("login", ["authUser"]),
    ...mapGetters({
        tienePermisosEnComponenteId : "login/tienePermisosEnComponenteId"
    }),
    // parte: {
    //   get() {
    //       return this.$store.getters['acciones/parte']
    //   },
    //   set(newValue) {
    //       return this.$store.dispatch('acciones/setParte', newValue);
    //   }
    // },
    contratosActivos() {
      return this.contratos.filter((contrato) =>
        this.parte.tipoParte_id === null ||
        this.parte.tipoParte_id === undefined ||
        this.parte.estadoParte_id > 2
          ? contrato.activo === true && contrato.id !== 7
          : (contrato.id === this.parte.tipoParte_id || !contrato.bolsa) && (this.parte.tipoParte_id === 7 || contrato.id !== 7)
      );
    },
    errorUsuario() {
      if (this.$v.accion.user.id.$dirty) {
        if (this.$v.accion.user.id.$invalid) {
          return "Introduce el usuario de la acción";
        }
      }
    },
    errorContrato() {
      if (this.$v.accion.contrato.id.$dirty) {
        if (this.$v.accion.contrato.id.$invalid) {
          return "Selecciona un contrato";
        }
      }
    },
    errorAmbito() {
      if (this.$v.accion.ambito.id.$dirty) {
        if (this.$v.accion.ambito.id.$invalid) {
          return "Introduce el ámbito de la acción";
        }
      }
    },
    errorUrgencia() {
      if (this.$v.accion.urgencia.id.$dirty) {
        if (this.$v.accion.urgencia.id.$invalid) {
          return "Introduce el grado de urgencia de la acción";
        }
      }
    },
    errorFecha() {
      if (this.$v.accion.fecha.$dirty) {
        if (this.$v.accion.fecha.$invalid) {
          return "Introduce la fecha de la acción";
        }
      }
    },
    errorEntrada() {
      if (this.$v.accion.entrada.$dirty) {
        if (this.$v.accion.entrada.$invalid) {
          return "Introduce la hora de inicio de la acción";
        }
      }
    },
    errorEntradaTarde() {
      if (this.$v.horaInicioTarde.$dirty) {
        if (this.$v.horaInicioTarde.$invalid) {
          if(!this.$v.horaInicioTarde.required){
            return "Introduce la hora de inicio de la acción de la tarde";
          }
          if (!this.$v.horaInicioTarde.greaterOrEqualThan) {
            return "La hora de entrada debe de ser posterior a la hora de salida de la mañana";
          }
        }
      }
    },
    errorSalida() {
      if (this.$v.accion.salida.$dirty) {
        if (this.$v.accion.salida.$invalid) {
          if(!this.$v.accion.salida.required){
            return "Introduce la hora de finalización de la acción";
          }
          if(!this.$v.accion.salida.greaterOrEqualThan){
            return "La hora de salida debe de ser posterior a la hora de entrada";
          }
        }
      }
    },
    errorSalidaTarde() {
      if (this.$v.horaFinTarde.$dirty) {
        if (this.$v.horaFinTarde.$invalid) {
          if (!this.$v.horaFinTarde.required) {
            return "Introduce la hora de finalización de la acción de la tarde";
          }
          if (!this.$v.horaFinTarde.greaterOrEqualThan) {
            return "La hora de salida debe de ser posterior a la hora de entrada";
          }
        }
      }
    },
    errorComentarios() {
      if (this.$v.accion.comentarios.$dirty) {
        if (this.$v.accion.comentarios.$invalid) {
          return "Introduce el comentario de la acción";
        }
      }
    },
    soloLectura() {
      return this.parte.estadoParte_id == 5 || this.parte.bloqueado;
    },
    delegacionParte(){
      let delegacion = this.delegaciones.find(delegacion => delegacion.delegacionId === this.parte.delegacion_id)
      return delegacion.direccion+' - '+delegacion.city
    }
  },
  mounted() {
    this.setHorasPonderadas(this.parte.acciones);
  },
  watch: {
    "accion.fecha"() {
      this.accion.fechaFormateada = this.formatDate(this.accion.fecha);
    },
  },
};
</script>

<style scoped>
/* .comentario {
  line-height: 1rem !important;
  font-size: 14px;
} */
</style>